module.exports = __webpack_public_path__ + "img/dock.6178a259.svg";